module.exports = __webpack_public_path__ + "img/img03.35293b91.png";